// Form.js
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, FormProvider } from "react-hook-form";

const Form = ({ onSubmit, children, className, options, id, schema, formRef }) => {
  const form = useForm({
    ...options,
    resolver: zodResolver(schema),
  });

  return (
    <FormProvider {...form}>
      <form
        className={`${className || ""}`}
        onSubmit={form.handleSubmit(onSubmit)}
        id={id}
        ref={formRef}
      >
        {children(form)}
      </form>
    </FormProvider>
  );
};

export { Form, FormProvider };
